// extracted by mini-css-extract-plugin
module.exports = {"video_thumbnail_carousel":"VideoThumbnailCarousel_video_thumbnail_carousel___IC1f","splide__arrow":"VideoThumbnailCarousel_splide__arrow__IN9Wj"};